// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, react/display-name */

// @ts-nocheck
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import _ from "lodash";
import { useControl } from "react-map-gl/mapbox";

import type { ControlPosition, IControl } from "react-map-gl/mapbox";
import LineMeasurementMode from "../../../../Lumber/OrthoViewer/DrawModes/LineMeasurementMode";
import PolygonMeasureMode from "../../../../Lumber/OrthoViewer/DrawModes/PolygonMeasureMode";
import PointMode from "../../../../Lumber/OrthoViewer/DrawModes/PointMode";
import React, { useImperativeHandle } from "react";
import { GeoJSONFeature } from "mapbox-gl";

export const MeasureModes = {
	line_measure: LineMeasurementMode,
	polygon_measure: PolygonMeasureMode,
	point: PointMode,
};

type DrawControlProps = ConstructorParameters<typeof MapboxDraw>[0] & {
	position?: ControlPosition;

	onCreate?: (evt: { features: GeoJSONFeature[] }) => void;
	onUpdate?: (evt: { features: GeoJSONFeature[]; action: string }) => void;
	onDelete?: (evt: { features: GeoJSONFeature[] }) => void;
};

const noop = () => {};

export const DrawControl = React.forwardRef<MapboxDraw & IControl, DrawControlProps>(
	({ onCreate = noop, onUpdate = noop, onDelete = noop, ...props }: DrawControlProps, ref) => {
		// FIXME: Adding the '& IControl' because MapboxDraw is outdated
		const drawRef = useControl<MapboxDraw & IControl>(
			() => new MapboxDraw(props),
			({ map }) => {
				map.on("draw.create", onCreate);
				map.on("draw.update", onUpdate);
				map.on("draw.delete", onDelete);
			},
			({ map }) => {
				map.off("draw.create", onCreate);
				map.off("draw.update", onUpdate);
				map.off("draw.delete", onDelete);
			},
			{
				position: props.position,
			},
		);

		useImperativeHandle(ref, () => drawRef, [drawRef]);

		return null;
	},
);

export default { DrawControl, MeasureModes };
